import React, { useCallback, useContext } from 'react';

// MUI
import { ButtonGroup, Button, useMediaQuery, useTheme } from '@mui/material';
import CompareIcon from '@mui/icons-material/Compare';
import RestoreIcon from '@mui/icons-material/Restore';
// import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MapContext from '@/context/MapContext/MapContext';

export interface LayerTreeActionsProps {
  setSwipeValue?: React.Dispatch<React.SetStateAction<number | null>>;
  allowSwiperSlider: boolean;
  onClearSwipeState: () => void;
 
}

const LayerTreeActions = ({ setSwipeValue, allowSwiperSlider, onClearSwipeState }: LayerTreeActionsProps) => {
  // const navigate = useNavigate();

  const { t } = useTranslation();
  const mapContext = useContext(MapContext);

  const theme = useTheme();
  const smDown = useMediaQuery(theme.breakpoints.down('sm'));

  const handleSetSwipeValue = useCallback(() => {
    if (setSwipeValue) {
      if (setSwipeValue) {
        setSwipeValue((prev) => (prev === null ? 500 : null));
      }
    }
  }, [setSwipeValue]);

  // const handleNavigateToLegend = () => {
  //   navigate(`${window.location.pathname}#legend`, { replace: true });
  // };

  const handleReset = () => {
    onClearSwipeState();
    mapContext?.clearLayerVisibility();
    mapContext?.clearLayerOpacity();
    mapContext?.clearLayerHistory();
  };

  return (
    <ButtonGroup
      variant="contained"
      aria-label="Layer tree action group"
      fullWidth
      sx={{
        position: 'sticky',
        top: '54px', // sits right below the sticky tabs bar (50px tall) in LayersPane
        zIndex: 1000,
        mx: '4px',
        width: 'calc( 100% - 8px )', // adjust for margin
      }}
    >
      {setSwipeValue ? (
        <Button
          startIcon={<CompareIcon />}
          onClick={handleSetSwipeValue}
          sx={{
            bgcolor: allowSwiperSlider ? 'primary.main' : 'primary.light',
            '&:hover': {
              bgcolor: 'primary.dark',
            },
          }}
        >
          {!smDown ? t('buttons.layer_compare') : ''}
        </Button>
      ) : null}
      {/* <Button
        startIcon={<i className="fas fa-list-alt" />}
        onClick={handleNavigateToLegend}
        sx={{
          bgcolor: 'primary.light',
          '&:hover': {
            bgcolor: 'primary.dark',
          },
        }}
      >
        {!smDown ? t('buttons.layer_legend') : ''}
      </Button> */}
      <Button
        startIcon={<RestoreIcon />}
        onClick={handleReset}
        sx={{
          bgcolor: 'primary.light',
          '&:hover': {
            bgcolor: 'primary.dark',
          },
        }}
      >
        {!smDown ? t('buttons.layer_reset') : ''}
      </Button>
    </ButtonGroup>
  );
};

export default LayerTreeActions;
